import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function InterPartners() {
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="card2__custom">
            <h4>Xorijiy hamkorlar</h4>
            <br />
            <p>
              В числе партнеров ТашФарми: <br />• Казахский Национальный
              Медицинский Университет (Казахстан) <br />• Южно-Казахстанский
              Государственный Университет (Казахстан) <br />
              • Евразийский национальный университет имени Л.Н. Гумилева
              (Казахстан) <br />
              • Дебреценский университет (Венгрия) <br />
              • Первый Московский государственный медицинский университет имени
              И. М. Сеченова (РФ) <br />
              • Changwon National University (Южная Корея) <br />
              • Воронежский государственный университет (РФ) <br />
              • Эгейский университет (Турция) <br />
              • Biruni University (Турция) <br />
            </p>
          </div>
          <div className="card3__custom">
            <div className="para__custom">
              <div className="qat1__custom">
                <img src="img/image 12.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 13.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 14.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 15.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 16.svg" alt />
              </div>
            </div>
            <div className="para__custom">
              <div className="qat1__custom">
                <img src="img/image 21.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 22.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 23.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 24.svg" alt />
              </div>
              <div className="qat1__custom">
                <img src="img/image 25.svg" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt"></div>
      <Footer />
    </div>
  );
}

export default InterPartners;
